export const PRODUCT_PAGE = "product page";
export const CART = "cart";
export const QUICK_BUY = "quick buy";
export const VTO = "vto";
export type AddToCartContext =
    | typeof PRODUCT_PAGE
    | typeof CART
    | typeof QUICK_BUY
    | typeof VTO;
